<template>
  <div class="industry-wrap">
    <div class="w">
      <divider chinese="行业数据" english="MOST CURRENT INFORMATION"/>
      <ul class="tab-wrap">
        <li
        :class="['tab-item', {'active' : isActive == item.id}]"
        v-for="item in tabs"
        :key="item.id"
        @click="handleTabsChange(item)"
        >
        {{item.blockName}}
        </li>
      </ul>
      <div class="tab-con w">
        <div v-for="item in blockContents" :key="item.id"  @click="handleCardClick(item.id)">
          <el-card class="tab-con-list">
            <div slot="header" class="tab-con-header">
              <span class="title" :title="item.contentTitle">{{item.contentTitle}}</span>
              <span class="timer">{{item.publishTime}}</span>
            </div>
            <p>{{item.content}}</p>
          </el-card>
        </div>
      </div>
      <div class="more" @click="handleMoreClick(isActive)">
        <i class="el-icon-d-arrow-left"></i>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '../divider'
import http from '@/http/index'
export default {
  data () {
    return {
      tabs: [],
      blockContents: [],
      isActive: 0,
      blockName: ''
    }
  },
  created () {
    this.params = {
      level: '1'
    }
    this.getBlockNames(this.params)
  },
  methods: {
    handleMoreClick (id) {
      this.$store.state.isActive = 'newActive'
      this.$router.push({
        name: 'news',
        params: {
          blockId: id
        }
      })
    },
    handleCardClick (id) {
      this.$store.state.isActive = 'newActive'
      this.$router.push({
        name: 'newsDetail',
        params: {
          id: id,
          blockName: this.blockName
        }
      })
    },
    handleTabsChange (item) {
      this.isActive = item.id
      this.blockContents = item.blockContents
      this.blockName = item.blockName
    },
    getBlockNames (parems) {
      http.getBlockNames(parems).then(res => {
        let contents = ''
        if (res.data.data && Array.isArray(res.data.data)) {
          contents = res.data.data[1]
        }
        return contents
      }).then(res => {
        this.getTabsInfo(res.id)
      })
    },
    getTabsInfo (id) {
      http.acquireFirstPortalTitleList({blockType: id}).then(res => {
        this.tabs = res.data.data
        let data = res.data.data
        this.isActive = data[0].id
        this.blockContents = data[0].blockContents
        this.blockName = data[0].blockName
      })
    }
  },
  components: {
    divider
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/sass/variable.sass';
.industry-wrap {
  width: 100%;
  height: 602px;
  background: url("~@/assets/images/databg.png") no-repeat;
  background-size: cover;
  position:relative;
  .w {
    width: $el-center;
    margin: 0 auto;
    .tab-wrap {
      display: flex;
      justify-content: center;
      margin: 40px 0;
      .tab-item{
        width: 120px;
        height: 38px;
        background: #fff;
        border-radius: 2px;
        text-align: center;
        line-height: 38px;
        color: $el-main-color;
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0,0,0,.1);
        &.active{
          color: #fff;
          background: $el-main-color;
        }
      }
    }
    .tab-con {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .tab-con-list {
        width: 380px;
        height: 185px;
        background: #fff;
        // margin-bottom: 27px;
        cursor: pointer;
        .tab-con-header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            color: $el-main-color;
            font-size: 18px;
            width: 200px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .timer {
            font-size: 12px;
            color: #999999;
          }
        }
        p{
          height: 75px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          color:#7B7B83;
          line-height: 24px;
        }
      }
    }
    .more {
      width: 60px;
      height: 60px;
      background: #fff;
      border-radius: 50%;
      text-align: center;
      line-height: 60px;
      color: #999;
      font-size: 30px;
      transform: rotate(-90deg);
      // position: absolute;
      // left: 50%;
      // bottom: -30px;
      margin:-31px auto 0;
      cursor: pointer;
      .el-icon-d-arrow-left {
        transform: translate3d(-10px, 0, 0);
        animation: move 1s ease-in-out infinite alternate;
      }
      .el-icon-d-arrow-left:hover {
        color:$el-main-color;
      }
    }
  }
}
@keyframes move {
  0% {transform: translate3d(-5px, 0, 0);}
  100% {transform: translate3d(-10px, 0, 0)}
}
</style>



// WEBPACK FOOTER //
// src/components/home/industry.vue